import { MANUAL_IDENTIFICATION, PSD2_BANKS } from 'Router/routes';
import { IdentificationStatusProps } from 'pages/Registration/WelcomeBack/IdentificationStatus/types';

const bankAccountStatusMap: Record<string, IdentificationStatusProps> = {
  REQUESTED: {
    type: 'warning',
    title: 'welcome_back:bank_account_requested.title',
    description: 'welcome_back:bank_account_requested.description',
    navigateTo: PSD2_BANKS,
    statusType: 'bankAccountStatus',
  },
  PSD2_PAYMENT_ERROR: {
    type: 'warning',
    title: 'welcome_back:bank_account_psd2_payment_error.title',
    description: 'welcome_back:bank_account_psd2_payment_error.description',
    navigateTo: MANUAL_IDENTIFICATION,
    statusType: 'bankAccountStatus',
  },
  PSD2_NAME_SURNAME_MISMATCH: {
    type: 'warning',
    title: 'welcome_back:bank_account_psd2_name_surname_mismatch.title',
    description:
      'welcome_back:bank_account_psd2_name_surname_mismatch.description',
    navigateTo: PSD2_BANKS,
    statusType: 'bankAccountStatus',
  },
  BANKID_IN_PROGRESS: {
    type: 'warning',
    title: 'welcome_back:bank_account_bank_id_in_progress.title',
    description: 'welcome_back:bank_account_bank_id_in_progress.description',
    navigateTo: PSD2_BANKS,
    statusType: 'bankAccountStatus',
  },
  PSD2_PAYMENT_INITIATED: {
    type: 'waiting',
    title: 'welcome_back:bank_account_psd2_payment_initiated.title',
    description: 'welcome_back:bank_account_psd2_payment_initiated.description',
    statusType: 'bankAccountStatus',
  },
  PSD2_PAYMENT_SENT: {
    type: 'waiting',
    title: 'welcome_back:bank_account_psd2_payment_sent.title',
    description: 'welcome_back:bank_account_psd2_payment_sent.description',
    statusType: 'bankAccountStatus',
  },
  PSD2_PAYMENT_SENT_WITH_INCOME: {
    type: 'waiting',
    title: 'welcome_back:bank_account_psd2_payment_sent.title',
    description: 'welcome_back:bank_account_psd2_payment_sent.description',
    statusType: 'bankAccountStatus',
  },
  APPROVED: {
    type: 'warning',
    title: 'welcome_back:bank_account_approved.title',
    description: 'welcome_back:bank_account_approved.description',
    statusType: 'bankAccountStatus',
    navigateTo: PSD2_BANKS,
  },
  APPROVED_WITH_INCOME: {
    type: 'success',
    title: 'welcome_back:bank_account_approved_with_income.title',
    statusType: 'bankAccountStatus',
  },
};

export default bankAccountStatusMap;
